var map = {
	"./1.mp4": "a42c",
	"./2.mp4": "989c",
	"./3.mp4": "fb9a",
	"./4.mp4": "7aaf",
	"./5.mp4": "779b",
	"./6.mp4": "b464"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbf6";